import {Component} from './component';

export class WysiwygEditor extends Component {

    setup() {
        this.elem = this.$el;
        this.editContainer = this.$refs.editContainer;
        this.input = this.$refs.input;
        this.markdownInput = this.$refs.markdownInput;

        /** @var {SimpleWysiwygEditorInterface|null} */
        this.editor = null;

        const translations = {
            ...window.editor_translations,
            imageUploadErrorText: this.$opts.imageUploadErrorText,
            serverUploadLimitText: this.$opts.serverUploadLimitText,
        };

        window.importVersioned('wysiwyg').then(wysiwyg => {
            const editorContent = this.input.value;
            this.editor = wysiwyg.createPageEditorInstance(this.editContainer, editorContent, {
                drawioUrl: this.getDrawIoUrl(),
                pageId: Number(this.$opts.pageId),
                darkMode: document.documentElement.classList.contains('dark-mode'),
                textDirection: this.$opts.textDirection,
                translations,
            });
            window.wysiwyg = this.editor;
        });

        let handlingFormSubmit = false;
        this.input.form.addEventListener('submit', event => {
            console.log('[WYSIWYG Editor] ========== Form submit event ==========');
            if (!this.editor) {
                console.error('[WYSIWYG Editor] Editor not initialized!');
                return;
            }

            if (!handlingFormSubmit) {
                event.preventDefault();
                handlingFormSubmit = true;

                console.log('[WYSIWYG Editor] Getting HTML content...');
                const htmlPromise = this.editor.getContentAsHtml();

                console.log('[WYSIWYG Editor] Getting Markdown content...');
                const markdownPromise = this.editor.getContentAsMarkdown();

                // Wait for both HTML and Markdown
                Promise.all([htmlPromise, markdownPromise]).then(([html, markdown]) => {
                    console.log('[WYSIWYG Editor] ✅ Got HTML, length:', html.length);
                    console.log('[WYSIWYG Editor] ✅ Got Markdown, length:', markdown.length);
                    console.log('[WYSIWYG Editor] Markdown preview:', markdown.substring(0, 200));

                    // Populate both fields
                    this.input.value = html;
                    if (this.markdownInput) {
                        this.markdownInput.value = markdown;
                        console.log('[WYSIWYG Editor] ✅ Markdown field populated!');
                    } else {
                        console.warn('[WYSIWYG Editor] ⚠️ Markdown input field not found!');
                    }

                    console.log('[WYSIWYG Editor] Submitting form...');
                    setTimeout(() => {
                        this.input.form.requestSubmit();
                    }, 5);
                });
            } else {
                handlingFormSubmit = false;
                console.log('[WYSIWYG Editor] Form submitted!');
            }
        });
    }

    getDrawIoUrl() {
        const drawioUrlElem = document.querySelector('[drawio-url]');
        if (drawioUrlElem) {
            return drawioUrlElem.getAttribute('drawio-url');
        }
        return '';
    }

    /**
     * Get the content of this editor.
     * Used by the parent page editor component.
     * @return {Promise<{html: String, markdown: String}>}
     */
    async getContent() {
        console.log('[WYSIWYG Editor] ========== getContent() called ==========');

        if (!this.editor) {
            console.error('[WYSIWYG Editor] ❌ Editor not initialized!');
            return { html: '', markdown: '' };
        }

        console.log('[WYSIWYG Editor] Editor object:', this.editor);
        console.log('[WYSIWYG Editor] Has getContentAsMarkdown?', typeof this.editor.getContentAsMarkdown);

        const html = await this.editor.getContentAsHtml();
        console.log('[WYSIWYG Editor] ✅ HTML length:', html.length);

        const markdown = await this.editor.getContentAsMarkdown();
        console.log('[WYSIWYG Editor] ✅ Markdown length:', markdown.length);
        console.log('[WYSIWYG Editor] Markdown preview:', markdown.substring(0, 200));

        const result = {
            html: html,
            markdown: markdown,
        };
        console.log('[WYSIWYG Editor] ========== Returning result ==========', result);

        return result;
    }

}
